import { Injectable, ErrorHandler } from "@angular/core";
import { Router } from "@angular/router";
// import { environment } from "../../environments/environment";

declare let toastr: any;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private router: Router) {
        // toastr.options = {
        //     "closeButton": true,
        //     "debug": false,
        //     "newestOnTop": true,
        //     "progressBar": false,
        //     "positionClass": "toast-bottom-right",
        //     "preventDuplicates": false,
        //     "onclick": null,
        //     "showDuration": "300",
        //     "hideDuration": "1000",
        //     "timeOut": "5000",
        //     "extendedTimeOut": "1000",
        //     "showEasing": "swing",
        //     "hideEasing": "linear",
        //     "showMethod": "fadeIn",
        //     "hideMethod": "fadeOut"
        // };
    }

    handleError(error: any): void {
        console.error(error);
        if (error.hasOwnProperty("status")) {
            if (error.status === 0) {
                toastr.error((error.statusText || '') + ' (' + error.status + '):' + ' Network error.');
                return;
            }
            else if (error.status === 401) {
                toastr.error((error.statusText || '') + ' (' + error.status + '):' + ' Please login to continue.');
                this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
                return;
            }
        }
        if (error.hasOwnProperty("error")) {
            const tmp = error.error;
            toastr.error("Error occured. " + (typeof (tmp.msg) == "string" ? tmp.msg : JSON.stringify(tmp)));
        } else {
            toastr.error("Error occured. " + (error.msg || error.message || error.ResponseText || JSON.stringify(error)));
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/error-handler.service.ts